export const BookingType = {
  WebAdmin: { code: 'WEB_ADMIN', name: 'Đặt Qua Website ADMIN' },
  AppDriver: { code: 'APP_DRIVER', name: 'Đặt Qua App DRIVER' },
  WebCustomer: { code: 'WEB_CUSTOMER', name: 'Đặt Qua Website CUSTOMER' },
  WebCustomerQR: {
    code: 'WEB_CUSTOMER_QR',
    name: 'Đặt Qua Website CUSTOMER Bằng Cách Quét Mã QR Từ Tài Xế',
  },
  AppCustomer: { code: 'APP_CUSTOMER', name: 'Đặt Qua App CUSTOMER' },
  AppCustomerQR: {
    code: 'APP_CUSTOMER_QR',
    name: 'Đặt Qua App CUSTOMER Bằng Cách Quét Mã QR Từ Tài Xế',
  },
  Partner: { code: 'PARTNER', name: 'Đối tác đặt chuyến' },
  PartnerQuick: {
    code: 'PARTNER_QUICK',
    name: 'Đối tác đặt chuyến (Đặt Nhanh)',
  },
  PartnerQR: {
    code: 'PARTNER_QR',
    name: 'Hành khách (Quét QR)',
    description: 'Khách hàng quét mã QR của partner',
  },
};

export const SourceType = {
  Admin: {
    code: 'ADMIN',
    name: 'Tổng đài viên',
    description: 'Tổng đài viên đặt chuyến',
  },
  Driver: { code: 'DRIVER', name: 'Tài xế', description: 'Tài xế đặt chuyến' },
  Customer: {
    code: 'CUSTOMER',
    name: 'Hành khách',
    description: 'Khách hàng đặt chuyến',
  },
  Partner: {
    code: 'PARTNER',
    name: 'Đối tác',
    description: 'Đối tác đặt chuyến',
  },
};

export const OrderType = {
  Now: {
    code: 'NOW',
    name: 'Đi ngay',
    description: 'Hành khách đặt chuyến đi ngay',
  },
  Timer: {
    code: 'TIMER',
    name: 'Hẹn giờ',
    description: 'Hành khách hẹn giờ cho chuyến đi',
  },
};
export const MessengerType = {
  Sms: { code: 'SMS', name: 'Tin nhắn SMS' },
  Whatsapp: { code: 'WHATSAPP', name: 'Whatsapp' },
};

export const OrderStatus = {
  New: {
    value: 'NEW',
    label: 'Chờ tài xế xác nhận',
    eLabel: 'Confirmed',
    color: 'primary',
    localize_name: 'order_status.NEW',
  },
  Wait: {
    value: 'WAIT',
    label: 'Chờ tài xế xác nhận',
    eLabel: 'Confirmed',
    color: 'info',
    localize_name: 'order_status.WAIT',
  },
  Confirm: {
    value: 'CONFIRM',
    label: 'Tài xế đang đến',
    eLabel: 'Driver on the way',
    color: 'secondary',
    localize_name: 'order_status.CONFIRM',
  },
  Doing: {
    value: 'DOING',
    label: 'Đang thực hiện',
    eLabel: 'In progress',
    color: 'warning',
    localize_name: 'order_status.DOING',
  },
  Complete: {
    value: 'COMPLETE',
    label: 'Đã hoàn thành',
    eLabel: 'Completed',
    color: 'success',
    localize_name: 'order_status.COMPLETE',
  },
  Cancel: {
    value: 'CANCEL',
    label: 'Đã hủy',
    eLabel: 'Cancelled',
    color: 'error',
    localize_name: 'order_status.CANCEL',
  },
};

export const PaymentType = {
  Cash: {
    code: 'CASH',
    name: 'Tiền mặt',
    description: 'Hành khách thanh toán tiền mặt',
    localize_name: 'payment_methods.CASH',
  },
  VNPAY: {
    code: 'VNPAY',
    name: 'VnPay',
    description: 'Hành khách thanh toán bằng ví điện tử VN Pay',
    localize_name: 'payment_methods.VNPAY',
  },
  MBBANK: {
    code: 'MBBANK',
    name: 'MB Bank',
    description: 'Hành khách thanh toán bằng MB Bank',
    localize_name: 'payment_methods.MBBANK',
  },
  PAYPAL: {
    code: 'PAYPAL',
    name: 'Paypal',
    description: 'Hành khách thanh toán bằng Paypal',
    localize_name: 'payment_methods.PAYPAL',
  },
  DEBT_COMPANY: {
    code: 'DEBT_COMPANY',
    name: 'Công nợ công ty',
    description: 'Công nợ công ty',
    localize_name: 'payment_methods.DEBT_COMPANY',
  },
  DEBT_EMPLOYEE: {
    code: 'DEBT_EMPLOYEE',
    name: 'Công nợ Điều hành',
    description: 'Công nợ Điều hành',
    localize_name: 'payment_methods.DEBT_EMPLOYEE',
  },
  DEBT_SALE: {
    code: 'DEBT_SALE',
    name: 'Công nợ Sale',
    description: 'Công nợ Sale',
    localize_name: 'payment_methods.DEBT_SALE',
  },
  OnePay: {
    code: 'ONEPAY',
    name: 'OnePay',
    description: 'Hành khách thanh toán bằng OnePay',
    localize_name: 'payment_methods.ONEPAY',
  },
};

export const PaymentStatus = {
  NonPaid: {
    code: 'NON_PAID',
    name: 'Chưa thanh toán',
    description: 'Hành khách Chưa thanh toán',
  },
  Paid: {
    code: 'PAID',
    name: 'Đã thanh toán',
    description: 'Hành khách Đã thanh toán',
  },
};

export const ERROR_VALIDATE = 'Dữ liệu không hợp lệ!';
export const ERROR_NOT_FOUND_DATA = 'Không tìm thấy dữ liệu!';

export const SOCKET_CONFIG = {
  HAS_CHANGE_ORDER_INSIDE: 'HAS_CHANGE_ORDER_INSIDE',
  PAYMENT_CUSTOMER_ORDER: 'PAYMENT_CUSTOMER_ORDER',
  TRACKING_CAR_LIST: 'TRACKING_CAR_LIST',
  PAYMENT_EWALLET_ORDER: 'PAYMENT_EVALLET_ORDER',
};

export const SocketType = {
  CreateData: 'CreateData',
  CreateDataQuick: 'CreateDataQuick',
  UpdateStatusWait: 'UpdateStatusWait',
  UpdateStatusConfirm: 'UpdateStatusConfirm',
  UpdateStatusReject: 'UpdateStatusReject',
  UpdateStatusDoing: 'UpdateStatusDoing',
  UpdateStatusCancel: 'UpdateStatusCancel',
  UpdateStatusComplete: 'UpdateStatusComplete',
  UpdateData: 'UpdateData',
  UpdatePaymentCash: 'UpdatePaymentCash',
  UpdatePayment: 'UpdatePayment',
  UpdatePaymentVNPaySuccess: 'UpdatePaymentVNPaySuccess',
  UpdatePaymentMbBankSuccess: 'UpdatePaymentMbBankSuccess',
  UpdatePaymentPaypalSuccess: 'UpdatePaymentPaypalSuccess',
  UpdatePaymentOnePaySuccess: 'UpdatePaymentOnePaySuccess',
  UpdatePaymentOnePayFail: 'UpdatePaymentOnePayFail',
};

export const TourAdventureTime = {
  goNow: {
    title: 'common:goNow',
    value: -1,
  },
};

export const NotifyStatus = {
  READ: 'DaDoc',
  NOT_READ: 'ChuaDoc',
};

export const ContactNumberType = {
  Phone: {
    code: 'phone',
    name: 'phone',
  },
  Zalo: {
    code: 'zalo',
    name: 'Zalo',
  },
  Whatsapp: {
    code: 'whatsapp',
    name: 'Whatsapp',
  },
  Kakaotalk: {
    code: 'kakaotalk',
    name: 'Kakaotalk',
  },
  Viber: {
    code: 'viber',
    name: 'Viber',
  },
};
